
import apiClient from '../helpers/apiClient';
import { authHeader } from '../helpers/authHeader';


export const productSharingService = {
    productSharingList, productSharingDetails
    
};







async function  productSharingList() {
    return  apiClient.get(`/inventory/product-sharing`, authHeader());
}



async function  productSharingDetails(id) {
    return  apiClient.get(`/inventory/product-sharing-details/${id}`, authHeader());
}


// async function  deletePackage(id) {
//     return  apiClient.delete(`/inventory/delete-package/${id}`, authHeader());
// }











